import { createFileRoute } from "@tanstack/react-router"

import { ReviewPage } from "@/trips/components/trips/review-page"

export const Route = createFileRoute("/_app-shell/review")({
  head: () => ({ meta: [{ title: "Review - Kestly" }] }),
  component: ReviewPage,
})
